<template>
  <main-layout>
    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-07"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <!--  TODO: i18n  -->
        <label slot="title">設備種別</label>
        <!--  TODO: auth code  -->
        <!--  TODO: i18n  -->
        <sp-smart-button @click="clickCancel" slot="cancel">キャンセル</sp-smart-button>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
      <loading-dialog :dialog-visible="loading" />
      <div class="panel">
        <narrow-down class="margin-bottom-3" @click="clickAdd">設備種別を追加</narrow-down>
        <el-table class="margin-bottom-2" :data="deviceCategories">
          <el-table-column prop="categoryExId" label="設備種別ID">
          </el-table-column>
          <el-table-column prop="categoryName" label="設備種別名">
          </el-table-column>
          <el-table-column prop="tags" label="タグ" v-slot="scope">
            {{displayTags(scope.row.tags)}}
          </el-table-column>
          <el-table-column v-slot="row">
            <div class="buttons">
              <sp-smart-button class="btn btn-edit" @click="clickEdit(row.row.categoryId)">編集</sp-smart-button>
              <sp-smart-button class="btn btn-remove" @click="clickRemove(row.row.categoryId)">削除</sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import LoadingDialog from "@/components/common/loading/LoadingDialog";
import Menubar from "@/components/leftmenu/DashBoard";
import HeadTitle from "@/components/common/head/head";
import SpSmartButton from "@/components/common/sp-smart-button";
import NarrowDown from "@/components/common/generalButton/NarrowDown";
import api from '@/api/SystemManageApi';
import errorCodeMsg from "@/utils/error-code-msg";
import statusErrorCodeMsg from "@/utils/status-error-msg";

export default {
  name: "DeviceTypeList",
  components: { LoadingDialog, MainLayout, Menubar, HeadTitle, NarrowDown, SpSmartButton },
  data() {
    return {
      loading: false,
      buildingId: '',
      pagination: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 1000,
        pageNumber: 1
      },
      deviceCategories: [
        /**
         * {
         *   categoryId: '',
         *   categoryExId: 'A0001',
         *   categoryName: '環境センサー',
         *   tags: [{
         *     id: '',
         *     name: '',
         *     unit: '',
         *     label: ''
         *   }]
         * }
         */
      ]
    }
  },
  created() {
    // TODO: what is bread path?
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/buildings/search",
        title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
        path: "",
        title: "設備種別",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  methods: {
    clickAdd() {
      this.$router.push({
        name: 'deviceCategoryCreate',
        params: {
          buildingId: this.buildingId
        }
      });
    },

    clickCancel() {
      this.$router.push({
        name: 'system-building-manage-menu',
        params: {
          buildingId: this.buildingId
        }
      });
    },

    clickEdit(categoryId) {
      this.$router.push({
        name: 'deviceCategoryEdit',
        params: {
          buildingId: this.buildingId,
          categoryId: categoryId
        }
      });
    },

    clickRemove(categoryId) {
      this.loading = true;
      api.deviceCategoryDelete(categoryId)
        .then(({ data }) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return;
          }
          this.deviceCategories = this.deviceCategories.filter(category => category.categoryId !== categoryId);
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.loading = false;
        })
    },

    doneInit() {
      this.buildingId = this.$route.params.buildingId;
      this.loading = true;
      api.deviceCategorySearch({
        buildingId: this.buildingId,
        pageNumber: this.pagination.pageNumber,
        pageSize: this.pagination.pageSize
      })
      .then(({ data }) => {
        const { body } = data;
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          return;
        }
        if (body.body.length === 0) {
          //this.clickAdd();
        } else {
          this.pagination.totalPage  = body.totalPage;
          this.pagination.totalCount = body.totalCount;
          this.pagination.pageSize   = body.pageSize;
          this.pagination.pageNumber = body.pageNumber;
          this.deviceCategories = body.body.map(item => {
            return {
              categoryId: item.categoryId,
              categoryExId: item.categoryExId,
              categoryName: item.categoryName,
              tags: item.tagList.map(tag => ({
                id: tag.tagId,
                name: tag.tagCode,
                unit: tag.tagUnit,
                label: tag.tagName
              }))
            }
          });
        }
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.loading = false;
      })
    },

    displayTags(tags) {
      return tags.map(tag => tag.label).join('、');
    },

    onPaging({ pageSize, pageNumber }) {
      this.pagination.pageSize = pageSize;
      this.pagination.pageNumber = pageNumber;
      this.doneInit();
    }
  },
  mounted() {
    this.doneInit();
  }
}
</script>

<style scoped>
.buttons .btn {
  width: 56px;
  height: 32px;
  padding: initial;
}
</style>
